<script lang="ts">
	import { DataHandlerUserAdmin, type User } from "luxedo-data"
	import { LuxedoRPC } from "luxedo-rpc"
	import { Toast } from "toaster"
	import { onMount } from "svelte"
	import Header from "../../reusable/Header.svelte"
	import LoadingSpinner from "../../reusable/loaders/LoadingSpinner.svelte"
	import UsersTable from "./UsersTable.svelte"

	import type { BundledAccountData } from "luxedo-rpc/src/types/BundledTypes"

	let pageUsers: Array<BundledAccountData> = $state()
	let searchPageUsers: Array<Array<User>> = $state()

	let pageAmount = $state(0)
	let pageNumber = $state(0)
	let isLoading = $state(true)

	/**
	 * Filters all users whose name or email might include the passed input
	 */
	async function searchUsers(input: string) {
		if (input.length === 0) return updateUserList()
		isLoading = true
		Toast.success("Searching ALL users, this might take a few minutes.")

		const relevantIds = (await LuxedoRPC.api.admin.search_accounts_by_string(input)).ids
		await DataHandlerUserAdmin.pull(relevantIds)

		const userArray = DataHandlerUserAdmin.getMany(relevantIds) ?? []

		if (userArray.length === 0) {
			Toast.error("No users found.")
			updateUserList()
			isLoading = false
		} else updatePages(userArray)
	}

	/**
	 * Sets pageUsers to chunks of users, updating the page amount.
	 * Pass the array which is currently being viewed (e.g., allUsers or filteredUsers)
	 */
	function updatePages(userArray: Array<User>) {
		isLoading = true
		searchPageUsers = []

		const chunkSize = 20
		for (let i = 0; i < userArray.length; i += chunkSize) {
			const chunk = userArray.slice(i, i + chunkSize)
			searchPageUsers.push(chunk)
		}
		pageAmount = searchPageUsers.length
		pageNumber = 0
		isLoading = false
	}

	/**
	 * Update active page
	 */
	function navigatePage(isLeft: boolean) {
		if (isLeft) pageNumber--
		else pageNumber++
	}

	async function updateUserList() {
		isLoading = true
		const res = await LuxedoRPC.api.admin.get_accounts_by_page(pageNumber)
		searchPageUsers = undefined
		pageUsers = Object.values(res.data)
		pageAmount = res.total
		isLoading = false
	}

	onMount(updateUserList)
</script>

<Header
	heading={"Account List"}
	onNavigate={navigatePage}
	onSearch={searchUsers}
	{pageAmount}
	{pageNumber}
/>
{#if isLoading}
	<main>
		<LoadingSpinner loadingText="Loading users" />
	</main>
{:else}
	<UsersTable users={searchPageUsers ? searchPageUsers[pageNumber] : pageUsers} />
{/if}

<style>
	main {
		--loader-color: var(--color-accent);
		--loader-width: 20vw;

		width: 100%;
		height: calc(100vh - var(--header-height));
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
